export const PROMOTED_SPONSORSHIP = {
  ACTION_TYPES: {
    sponsorshipClick: 'sponsorshipClick',
    sponsorshipShow: 'sponsorshipShow'
  }
};